import React from 'react'
import { Table} from 'antd'

class OTPTable extends React.Component {
  constructor(props, context) {
    super(props, context)
  }

  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'idnum',
        key: 'idnum',
        sorter: (a, b) => (a.is_footer) ? 0 : a.idnum - b.idnum,
      },
      {
        title: 'Партнер',
        dataIndex: 's_sellers',
        key: 's_sellers',
        sorter: (a, b) => (a.is_footer) ? 0 : a.s_sellers.localeCompare(b.s_sellers),
      }, {
        title: 'Кол-во звонков',
        dataIndex: 'n_cnt',
        key: 'n_cnt',
        sorter: (a, b) => (a.is_footer) ? 0 : a.n_cnt - b.n_cnt,
      }, {
        title: 'Успешных звонков',
        dataIndex: 'n_success_cnt',
        key: 'n_success_cnt',
        sorter: (a, b) => (a.is_footer) ? 0 : a.n_success_cnt - b.n_success_cnt,
      }, {
        title: 'Кол-во сценариев',
        dataIndex: 'cnt_approve_all',
        key: 'cnt_approve_all',
        sorter: (a, b) => (a.is_footer) ? 0 : a.cnt_approve_all - b.cnt_approve_all,
      }, {
          title: 'Успешных сценариев',
          dataIndex: 'cnt_approve_success',
          key: 'cnt_approve_success',
          sorter: (a, b) => (a.is_footer) ? 0 : a.cnt_approve_success - b.cnt_approve_success,
      }, {
        title: 'Уникальных клиентов',
        dataIndex: 'cnt_customers_all',
        key: 'cnt_customers_all',
        sorter: (a, b) => (a.is_footer) ? 0 : a.cnt_customers_all - b.cnt_customers_all,
      }, {
        title: 'Безуспешных сценариев',
        dataIndex: 'n_approve_failed',
        key: 'n_approve_failed',
        sorter: (a, b) => (a.is_footer) ? 0 : a.n_approve_failed - b.n_approve_failed,
      }, {
        title: 'Безуспешных сценариев (%)',
        dataIndex: 'n_approve_failed_percent',
        key: 'n_approve_failed_percent',
        sorter: (a, b) => (a.is_footer) ? 0 : a.n_approve_failed_percent - b.n_approve_failed_percent,
        render: record => parseFloat(record).toFixed(2)
      }, {
        title: 'Стоимость звонка',
        dataIndex: 'n_price',
        key: 'n_price',
        sorter: (a, b) => (a.is_footer) ? 0 :a.n_price - b.n_price,
        render: record => parseFloat(record).toFixed(2)
      }, {
        title: 'Бюджет на звонки',
        dataIndex: 'n_amount',
        key: 'n_amount',
        sorter: (a, b) => (a.is_footer) ? 0 : a.n_amount - b.n_amount,
        render: record => parseFloat(record).toFixed(2)
      }
    ]

    return (
      <Table
        rowKey={record => `item-row-${record.idnum}`}
        columns={columns}
        {...this.props}
      />
    )
  }
}

export default OTPTable



// WEBPACK FOOTER //
// src/containers/Dashboard/OTPStat/Table.jsx